import { useEffect, useState } from "react";
import { api } from "../api/client.js";

interface Publication { id: string; status: string; title?: string; scheduled_at?: string; published_at?: string; platform?: string; influencer_id: string; }

export function CalendarPage() {
  const [publications, setPublications] = useState<Publication[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<{ publications: Publication[] }>("/publications?limit=50")
      .then(r => setPublications(r.publications ?? []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const statusColor = (s: string) => ({
    draft: "#6366f1", scheduled: "#d97706", confirmed_manual: "#2d6a4f",
    exported: "#1d4ed8", cancelled: "#9ca3af"
  }[s] || "#6b7280");

  const statusLabel = (s: string) => ({
    draft: "Borrador", scheduled: "Programada", confirmed_manual: "Publicado manual",
    exported: "Exportada", cancelled: "Cancelada"
  }[s] || s);

  if (loading) return <div style={{ padding: 24, color: "#888" }}>Cargando…</div>;

  const grouped: Record<string, Publication[]> = {};
  publications.forEach(p => {
    const d = new Date(p.scheduled_at || p.published_at || p.id);
    const key = isNaN(d.getTime()) ? "Sin fecha" : d.toLocaleDateString("es", { month: "long", year: "numeric" });
    (grouped[key] = grouped[key] || []).push(p);
  });

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Calendario</h1>
        <p style={{ color: "#666", fontSize: 13, margin: "4px 0 0" }}>{publications.length} publicaciones</p>
      </div>

      <div style={{ background: "#fef9c3", border: "1px solid #fde68a", borderRadius: 8, padding: "10px 16px", marginBottom: 20, fontSize: 13, color: "#92400e" }}>
        Publicaciones externas desactivadas por defecto (OUTBOUND_ACTIONS_ENABLED=false). El calendario muestra planes y exportaciones manuales.
      </div>

      {publications.length === 0 ? (
        <div style={{ background: "#fff", borderRadius: 10, padding: 40, textAlign: "center", color: "#888" }}>
          Sin publicaciones planificadas. Crea sesiones y exporta contenido para planificar publicaciones.
        </div>
      ) : (
        Object.entries(grouped).map(([month, pubs]) => (
          <div key={month} style={{ marginBottom: 24 }}>
            <h3 style={{ fontSize: 14, fontWeight: 600, color: "#888", marginBottom: 10, textTransform: "capitalize" }}>{month}</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {pubs.map(p => (
                <div key={p.id} style={{ background: "#fff", borderRadius: 8, padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 500 }}>{p.title || "Publicación sin título"}</div>
                    <div style={{ fontSize: 12, color: "#aaa", marginTop: 2 }}>
                      {p.platform || "Sin plataforma"} ·{" "}
                      {p.scheduled_at ? new Date(p.scheduled_at).toLocaleString("es") : "Sin hora"}
                    </div>
                  </div>
                  <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 12, background: statusColor(p.status) + "22", color: statusColor(p.status), fontWeight: 600 }}>
                    {statusLabel(p.status)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
